import { render } from "./FriendChatIn.vue?vue&type=template&id=334a1ae5&scoped=true"
import script from "./FriendChatIn.vue?vue&type=script&lang=js"
export * from "./FriendChatIn.vue?vue&type=script&lang=js"

import "./FriendChatIn.vue?vue&type=style&index=0&id=334a1ae5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334a1ae5"]])

export default __exports__